/* eslint-disable jira/filename-case */
/**
 * Extracts and compiles key performance metrics from the DOM to assess server response times and request handling efficiency.
 * This includes metrics like server duration, trace IDs, concurrency levels, and timing details, which are crucial for analyzing server behavior and identifying potential bottlenecks.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerDurationMetrics = (): Record<string, any> => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const metrics: Record<string, any> = {};
	try {
		// server duration metric is buried in a hidden form near end of </body>

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const serverDurationElem = document.querySelector(
			'#jira_request_timing_info [title="jira.request.server.time"]',
		);
		if (serverDurationElem) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const serverDuration = Number((serverDurationElem as HTMLInputElement).value);
			if (serverDuration > 0) {
				metrics.serverDuration = Math.round(serverDuration);
			}
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const serverTraceIdElem = document.querySelector(
			'#jira_request_timing_info [title="jira.request.trace.id"]',
		);
		if (serverTraceIdElem) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const serverRequestTraceId = (serverTraceIdElem as HTMLInputElement).value;
			metrics.serverRequestTraceId = serverRequestTraceId;
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const serverTraceSampledElem = document.querySelector(
			'#jira_request_timing_info [title="jira.request.sampled"]',
		);
		if (serverTraceSampledElem) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const serverRequestTraceSampled = (serverTraceSampledElem as HTMLInputElement).value;
			switch (serverRequestTraceSampled) {
				case 'true':
					metrics.serverRequestTraceSampled = true;
					break;
				case 'false':
					metrics.serverRequestTraceSampled = false;
					break;
				default:
					metrics.serverRequestTraceSampled = null;
					break;
			}
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const concurrentRequestsElem = document.querySelector(
			'#jira_request_timing_info [name="jira.request.concurrent.requests"]',
		);
		if (concurrentRequestsElem) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const concurrentRequests = (concurrentRequestsElem as HTMLInputElement).value;
			metrics.concurrentRequests = concurrentRequests;
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const serverRequestStartTimeElem = document.querySelector(
			'#jira_request_timing_info [name="jira.request.start.millis"]',
		);
		if (serverRequestStartTimeElem) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const serverRequestStartTime = (serverRequestStartTimeElem as HTMLInputElement).value;
			metrics.serverRequestStartTime = serverRequestStartTime;
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const frontendFlushStartTimeElem = document.querySelector(
			'#jira_request_timing_info [name="jira.request.frontend.flush.start"]',
		);
		if (frontendFlushStartTimeElem) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const frontendFlushStartTime = (frontendFlushStartTimeElem as HTMLInputElement).value;
			metrics.frontendFlushStartTime = frontendFlushStartTime;
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (ignored: any) {
		/* noop */
	}
	return metrics;
};
